import protoRoot from "../proto-root";

const name = "getSignedUrlRpcresponse";

function create(signedUrl) {
  const GetSignedUrlRpcResponse = protoRoot.lookupType(
    "comm.GetSignedUrlRpcResponse"
  );

  const response = GetSignedUrlRpcResponse.create({
    signedUrl
  });
  return { payload: response, name };
}

export default {
  create,
  name
};
